import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {
  SessionGender,
  useSessionGender,
} from '../../../shared-deprecated/sessionGender';
import {filterLogoAssets} from '../assets';

enum BAS_BRANDS {
  edited = 'edited',
  tommyHilfiger = 'tommyHilfiger',
  guidoMaria = 'guidoMaria',
  lascana = 'lascana',
  puma = 'puma',
  hugo = 'hugo',
  netflix = 'netflix',
}

export const useBasCampaign = () => {
  const getInfoByGender = useGetInfoByGender();

  const {isActive: isEditedBasCampaignActive} = useIsFeatureActive(
    'bas_homepage_campaign_takeover_edited',
  );

  const {isActive: isEditedBasCampaignActive2} = useIsFeatureActive(
    'bas_homepage_campaign_takeover_edited',
  );

  const {isActive: isGuidoMariaBasCampaignActive} = useIsFeatureActive(
    'bas_homepage_campaign_takeover_guido_maria',
  );

  const {isActive: isLascanaBasCampaignActive} = useIsFeatureActive(
    'bas_homepage_campaign_takeover_lascana',
  );

  const {isActive: isLascanaBasCampaignActive2} = useIsFeatureActive(
    'bas_homepage_campaign_takeover_lascana_2',
  );

  const {isActive: isLascanaBasCampaignActive3} = useIsFeatureActive(
    'bas_homepage_campaign_takeover_lascana_3',
  );

  const {isActive: isPumaBasCampaignActive} = useIsFeatureActive(
    'bas_homepage_campaign_puma',
  );

  const {isActive: isHugoBasCampaignActive} = useIsFeatureActive(
    'bas_homepage_campaign_hugo',
  );
  const {isActive: isTommyHilfigerBasCampaignActive} = useIsFeatureActive(
    'bas_homepage_campaign_takeover_tommy_hilfiger',
  );
  const {isActive: isNetflixBasCampaignActive} = useIsFeatureActive(
    'bas_homepage_campaign_netflix',
  );

  let result = null;

  if (isEditedBasCampaignActive) {
    result = basCampaignInfo.edited;
  } else if (isEditedBasCampaignActive2) {
    result = basCampaignInfo.tommyHilfiger;
  } else if (isGuidoMariaBasCampaignActive) {
    result = basCampaignInfo.guidoMaria;
  } else if (
    isLascanaBasCampaignActive ||
    isLascanaBasCampaignActive2 ||
    isLascanaBasCampaignActive3
  ) {
    result = basCampaignInfo.lascana;
  } else if (isPumaBasCampaignActive) {
    result = basCampaignInfo.puma;
  } else if (isHugoBasCampaignActive) {
    result = basCampaignInfo.hugo;
  } else if (isTommyHilfigerBasCampaignActive) {
    result = basCampaignInfo.tommyHilfiger;
  } else if (isNetflixBasCampaignActive) {
    result = basCampaignInfo.netflix;
  }

  return getInfoByGender(result);
};

const useGetInfoByGender = () => {
  const {gender} = useSessionGender();

  return (
    info: BASCampaignHeaderLogoTypes | BASCampaignHeaderLogoTypes[] | null,
  ) => {
    if (!info) {
      return null;
    }

    if (Array.isArray(info)) {
      if (!info.length) {
        return null;
      }

      const foundGender = info.find(
        item => item.gender && item.gender.includes(gender || 'female'),
      );

      if (foundGender) {
        return foundGender;
      }

      return null;
    }

    if (!info.gender) {
      return info;
    }

    // if gender is not defined use the default gender
    return info.gender.includes(gender || 'female') ? info : null;
  };
};

export const useIsHeaderBasCampaignActive = () => {
  const basCampaign = useBasCampaign();
  return basCampaign?.headerLogo !== undefined;
};

export type BASCampaignHeaderLogoTypes = {
  id: number;
  path: string;
  logoIntegrationName: string;
  topBannerName?: string;
  headerLogo?: {
    imagePath: string;
  };
  homePageBanner?: {
    imagePath: string;
  };
  gender?: Array<SessionGender>;
};

const basCampaignInfo: Record<
  BAS_BRANDS,
  BASCampaignHeaderLogoTypes | BASCampaignHeaderLogoTypes[]
> = {
  edited: {
    id: 4517,
    path: '/b/shop/edited-4517',
    logoIntegrationName:
      'Logo Integration_BAS_2022_CW35_Edited_AW22_Brand Material Campaign_C',
    headerLogo: {
      imagePath:
        'https://cdn.aboutstatic.com/file/images/651cc23de8f773a2a2c274f757c623a1.png?width=180',
    },
    topBannerName:
      'Top Banner_BAS_2022_CW35_Edited_AW22_Brand Material Campaign_C',
    homePageBanner: {
      imagePath:
        'https://cdn.aboutstatic.com/file/images/17aed7bb6aa062267530ed49207d0e2b.jpg?width=375',
    },
  },
  tommyHilfiger: [
    {
      id: 106800,
      path: '/s/tommy-hilfiger-106800',
      logoIntegrationName:
        'Logo Integration_BAS_2024_CW24_TOMMY HILFIGER_HPTO_Brand Material Campaign_A',
      headerLogo: {imagePath: filterLogoAssets.TommyHilfiger},
      gender: ['female'],
    },
    {
      id: 106805,
      path: '/s/tommy-hilfiger-106805',
      logoIntegrationName:
        'Logo Integration_BAS_2024_CW24_TOMMY HILFIGER_HPTO_Brand Material Campaign_A',
      headerLogo: {imagePath: filterLogoAssets.TommyHilfiger},
      gender: ['male'],
    },
  ],

  guidoMaria: {
    id: 77820,
    path: '/b/shop/guido-maria-kretschmer-collection-77820',
    logoIntegrationName:
      'Logo Integration_BAS_2023_CW21_Guido Maria Kretschmer_SS23_Brand Material Campaign_C',
    headerLogo: {
      imagePath: filterLogoAssets.GuidoMaria,
    },
    topBannerName:
      'Top Banner_BAS_2023_CW21_Guido Maria Kretschmer_SS23_Brand Material Campaign_C',
    homePageBanner: {
      imagePath:
        'https://cdn.aboutstatic.com/file/images/eaf7ddf3759a8f249ae69ff74a68d122.jpg?width=375',
    },
  },
  lascana: {
    id: 266,
    path: '/b/shop/lascana-266',
    logoIntegrationName:
      'Logo Integration_BAS_2023_CW35_Lascana_SS23_Brand Material Campaign_B',
    headerLogo: {
      imagePath: filterLogoAssets.Lascana,
    },
    topBannerName:
      'Top Banner_BAS_2023_CW35_Lascana_SS23_Brand Material Campaign_B',
    homePageBanner: {
      imagePath:
        'https://cdn.aboutstatic.com/file/images/00873daa88d5646ae921745139490dce.jpg?width=375',
    },
    gender: ['female'],
  },
  puma: {
    id: 105578,
    path: '/s/puma-105578',
    logoIntegrationName: '--',
    topBannerName:
      'Top Banner_BAS_2023_CW48_Puma_AW23_Brand Material Campaign_A',
    homePageBanner: {
      imagePath:
        'https://cdn.aboutstatic.com/file/images/4d69b7c6ce1619b055ad608d921ed7ac.jpg?width=375',
    },
    gender: ['female'],
  },
  hugo: [
    {
      id: 106027,
      path: '/s/hugo-106027',
      logoIntegrationName:
        'Logo Integration_BAS_2024_CW11_HUGO_SS24 II_Brand Material Campaign_A',
      headerLogo: {imagePath: filterLogoAssets.Hugo},
      topBannerName:
        'Top Banner_BAS_2024_CW11_HUGO_SS24 II_Brand Material Campaign_A',
      homePageBanner: {
        imagePath:
          'https://cdn.aboutstatic.com/file/images/0850c61b1b39c155c94b443775539faa.jpg?width=375',
      },
      gender: ['female'],
    },
    {
      id: 106028,
      path: '/s/hugo-106028',
      logoIntegrationName:
        'Logo Integration_BAS_2024_CW11_HUGO_SS24 II_Brand Material Campaign_A',
      headerLogo: {imagePath: filterLogoAssets.Hugo},
      topBannerName:
        'Top Banner_BAS_2024_CW11_HUGO_SS24 II_Brand Material Campaign_A',
      homePageBanner: {
        imagePath:
          'https://cdn.aboutstatic.com/file/images/0850c61b1b39c155c94b443775539faa.jpg?width=375',
      },
      gender: ['male'],
    },
  ],
  netflix: {
    id: 107660,
    path: '/s/netflix-collection-107660',
    headerLogo: {imagePath: filterLogoAssets.Netflix},
    logoIntegrationName:
      'Logo Integration_BAS_2024_CW44_NETFLIX_Laybels Cooperation_Brand Material Campaign_A',
    gender: ['female', 'male'],
  },
};
